import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles, useTheme } from '@mui/styles';


export default function DialogForm(props) {
    const { open, title, secondaryTitle, textContent, maxWidth = 'md', formContent, handleClose } = props;

    const theme = useTheme();

    // const useStyles = makeStyles(() => ({
    //     paper: { minWidth: "800px" },
    // }));

    return (
        <div>
            <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={maxWidth}
                sx={{
                    '& .MuiDialogTitle-root': {
                        fontSize: '1rem'
                    }
                }}>
                <DialogTitle>
                    {title}
                    {secondaryTitle ? <p style={{ margin: 0, color: theme.palette.primary.main }}>{secondaryTitle}</p> : ''}
                </DialogTitle>
                <DialogContent>
                    {textContent ? <DialogContentText>
                        {textContent}
                    </DialogContentText> : ''}
                    {formContent}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>FECHAR</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}